import { AbstractParser } from "../../parser";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { SalesHistoryCompanySummary } from "src/app/ui/models/domains/pbm/sales-history/sales-history-company-summary";
import { SalesHistoryProduct } from "src/app/ui/models/domains/pbm/sales-history/sales-history-product";

export class FindSalesHistoryParser extends AbstractParser<PageableResult> {
  parse(payload: any): PageableResult {
    const pageableResult = new PageableResult();
    pageableResult.setStart(payload.Start);
    pageableResult.setEnd(payload.End);
    pageableResult.setItems(this.parseSalesHistoryCompanySummary(payload.Items));

    return pageableResult;
  }

  private parseSalesHistoryCompanySummary(payload: any): SalesHistoryCompanySummary[] {
    const salesHistoryCompanySummaryList: SalesHistoryCompanySummary[] = [];

    payload.forEach((item) => {
      const salesHistoryCompanySummary = new SalesHistoryCompanySummary();
      salesHistoryCompanySummary.setFiscalNumber(item.FiscalNumber);
      salesHistoryCompanySummary.setCorporateName(item.CorporateName);
      salesHistoryCompanySummary.setProductSoldCount(item.ProductSoldCount);
      salesHistoryCompanySummary.setSalesHistoryProductList(this.parseSalesHistoryProduct(item.Products));

      salesHistoryCompanySummaryList.push(salesHistoryCompanySummary);
    });

    return salesHistoryCompanySummaryList;
  }

  private parseSalesHistoryProduct(payload: any): SalesHistoryProduct[] {
    const salesHistoryProductList: SalesHistoryProduct[] = [];

    payload.forEach((product) => {
      const salesHistoryProduct = new SalesHistoryProduct();
      salesHistoryProduct.setEan(product.Ean);
      salesHistoryProduct.setProductName(product.ProductName);
      salesHistoryProduct.setSoldItemQuantity(product.SoldItemQuantity);
      salesHistoryProduct.setSoldPrice(product.SoldPrice);

      salesHistoryProductList.push(salesHistoryProduct);
    });

    return salesHistoryProductList;
  }
}
